import React from 'react';
import type { JoinToast } from '../../hooks/useJoinToasts';

interface JoinToastStackProps {
  toasts: JoinToast[];
  onDismiss: (id: string) => void;
}

export function JoinToastStack({ toasts, onDismiss }: JoinToastStackProps) {
  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-6 right-4 z-50 flex w-64 flex-col gap-2 sm:right-6">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="sala-join-toast pointer-events-auto flex items-center gap-3 rounded-xl px-4 py-3"
          role="status"
        >
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/20 text-lg">
            ✓
          </span>
          <div className="min-w-0 flex-1">
            <p className="sala-label text-emerald-400">Se unió</p>
            <p className="truncate font-display text-sm font-bold">{toast.name}</p>
          </div>
          <button
            type="button"
            className="text-[var(--sala-ink-dim)] hover:text-[var(--sala-ink)]"
            onClick={() => onDismiss(toast.id)}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
